import * as actionTypes from "../../../actions/actionTypes";

const accountDetails = (
  state = {
    paymentMethods: [],
    dataChanged: false,
    achBankDetails: {},
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SET_ACCOUNT_DETAILS: {
      return { ...state, ...action.payload };
    }
    case actionTypes.SET_BANK_DETAILS: {
      return {
        ...state,
        achBankDetails: { ...state.achBankDetails, ...action.payload },
      };
    }
    case actionTypes.REMOVE_BANK_DETAILS: {
      return {
        ...state,
        achBankDetails: {},
      };
    }
    default:
      return state;
  }
};

export default accountDetails;
